import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdmins } from "../../../features/admins/adminsSlice";
import {
  addControlledSetNumber,
  removeControlledSetNumber,
} from "../../../features/controlledSetNumbers/controlledSetNumbersSlice";
import Loader from "../../loader/Loader";
import TextWrapper from "../../textWrapper/TextWrapper";
import styles from "./timelineTableHeader.module.css";
import { isSetExecutorRole } from "../../../constants/roleRules";

const TimelineTableHeader = ({ setNumber, tournamentId }) => {
  const [isExecuterMenuOpen, setIsExecuterMenuOpen] = useState(false);

  const dispatch = useDispatch();
  const { fetchStatus, list } = useSelector((state) => state.admins);
  const { controlledSetNumbers, addStatus, removeStatus } = useSelector(
    (state) => state.controlledSetNumbers,
  );
  const { rolePermissions } = useSelector((state) => state.user);
  // The executor picker (assign/remove a set's Co-Leader) has its own permission.
  const canAssignExecutors = rolePermissions.includes("assign-executors");

  useEffect(() => {
    if (
      fetchStatus === "idle" &&
      (canAssignExecutors || rolePermissions.includes("view-admins"))
    ) {
      dispatch(fetchAdmins());
    }
  }, [dispatch, fetchStatus, rolePermissions, canAssignExecutors]);

  const coLeaders = list.filter((admin) => isSetExecutorRole(admin?.role?.role));

  const handleAddSetNumber = (adminId) => {
    dispatch(addControlledSetNumber({ adminId, tournamentId, setNumber }));
  };

  const handleRemoveSetNumebr = (adminId) => {
    dispatch(removeControlledSetNumber({ adminId, tournamentId, setNumber }));
  };

  return (
    <td
      className={`${styles.timelineCell} ${styles.executerName}`}
      key={setNumber}
      onClick={() => setIsExecuterMenuOpen((prev) => !prev)}
    >
      {isExecuterMenuOpen &&
        canAssignExecutors && (
          <div className={styles.executerMenu}>
            {fetchStatus === "loading" ||
            addStatus === "loading" ||
            removeStatus === "loading" ? (
              <div className={styles.loaderContainer}>
                <Loader />
              </div>
            ) : (
              coLeaders.map((admin) => (
                <div
                  key={admin._id}
                  className={`${styles.executeniorWrapper} ${
                    controlledSetNumbers[tournamentId]?.[admin._id]?.includes(
                      +setNumber,
                    ) && styles.isControlled
                  }`}
                  onClick={() =>
                    controlledSetNumbers[tournamentId]?.[admin._id]?.includes(
                      +setNumber,
                    )
                      ? handleRemoveSetNumebr(admin._id)
                      : handleAddSetNumber(admin._id)
                  }
                >
                  {admin.name}
                </div>
              ))
            )}
          </div>
        )}
      <div className={styles.execturOpenWrapper}>
        <TextWrapper textStyle={"textMid"}>
          {setNumber >= 10000
            ? "منفذ الفاينل"
            : setNumber >= 1000
              ? "منفذ المرحله المتقدمه"
              : `المنفذ رقم ${setNumber}`}
        </TextWrapper>
        {canAssignExecutors && (
          <div
            className={
              isExecuterMenuOpen
                ? styles.arrowWrapper
                : `${styles.arrowWrapper} ${styles.open}`
            }
          >
            <span aria-hidden="true" className={styles.arrowGlyph}>
              ▾
            </span>
          </div>
        )}
      </div>
    </td>
  );
};

export default TimelineTableHeader;
